import { render } from "./OrderRow.vue?vue&type=template&id=2157a0e9&scoped=true&ts=true&lang=pug"
import script from "./OrderRow.vue?vue&type=script&lang=ts"
export * from "./OrderRow.vue?vue&type=script&lang=ts"

import "./OrderRow.vue?vue&type=style&index=0&id=2157a0e9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2157a0e9"]])

export default __exports__